import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "@/components/modal";
import { useDeleteOutboundFile, useOutboundSubmit } from "@/hooks/outbound";
import { showLegacyErrorToast } from "@/components/toast";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { EncounterForm } from "./encounter-form";
import { EncounterContextBanner } from "./encounter-context-banner";
import { EncounterFlowFooter } from "./encounter-flow-footer";
import { DocAccordions } from "./doc-accordions";
import { ReviewStep } from "./review-step";
import { validateEncounterDateTimes } from "./validate-date-times";
import { buildSubmissionPayload, generateRequestId, getDocOption, missingRequiredDocFields, missingRequiredFields } from "./build-submission-payload";
import { buildDocSummary, buildEncounterSummary } from "./submission-summary";
/** Unified modal to create an encounter (with optional document) or add a document to one. */
export function EncounterFlowModal(_ref) {
  var _getDocOption$label, _getDocOption;
  var action = _ref.action,
    encounter = _ref.encounter,
    encounterConfig = _ref.encounterConfig,
    encounterMeta = _ref.encounterMeta,
    docConfig = _ref.docConfig,
    docMeta = _ref.docMeta,
    workspaceId = _ref.workspaceId,
    patientId = _ref.patientId,
    isLoading = _ref.isLoading,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState({}),
    formData = _useState[0],
    setFormData = _useState[1];
  var _useState2 = useState(null),
    docKind = _useState2[0],
    setDocKind = _useState2[1];
  var _useState3 = useState(function () {
      return generateRequestId();
    }),
    requestId = _useState3[0];
  var _useState4 = useState(false),
    isReview = _useState4[0],
    setIsReview = _useState4[1];
  var _useState5 = useState(null),
    error = _useState5[0],
    setError = _useState5[1];
  var _useState6 = useState(new Set()),
    invalidFields = _useState6[0],
    setInvalidFields = _useState6[1];
  var submit = useOutboundSubmit(workspaceId, patientId);
  var deleteFile = useDeleteOutboundFile(workspaceId);
  var handleClose = function handleClose() {
    Object.keys(formData).forEach(function (key) {
      if (key.endsWith("__ct")) {
        var s3Key = formData[key.slice(0, -4)];
        if (s3Key) deleteFile.mutate(s3Key);
      }
    });
    onClose();
  };
  var handleDismiss = function handleDismiss() {
    trackEvent(ANALYTICS_EVENTS.ENCOUNTER_FLOW_CLOSE);
    handleClose();
  };
  var showDocs = action === "update" || action === "create" && Boolean(docConfig === null || docConfig === void 0 ? void 0 : docConfig.composite_request_allowed);
  var docRows = buildDocSummary(docConfig, docKind, formData);
  var encounterMissing = action === "create" ? missingRequiredFields(encounterConfig, formData) : [];
  var docMissing = missingRequiredDocFields(docConfig, docKind, formData);
  var canReview = action === "create" ? encounterMissing.length === 0 && docMissing.length === 0 : docRows.length > 0 && docMissing.length === 0;
  var setField = function setField(key, value) {
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, value));
    });
    setInvalidFields(function (prev) {
      if (!prev.has(key)) return prev;
      var next = new Set(prev);
      next["delete"](key);
      return next;
    });
  };
  var handleReview = function handleReview() {
    if (action === "create") {
      var result = validateEncounterDateTimes(encounterConfig, formData, t);
      if (!result.isValid) {
        var _result$errorMessages;
        setInvalidFields(new Set(result.invalidFieldNames));
        showLegacyErrorToast((_result$errorMessages = result.errorMessages[0]) !== null && _result$errorMessages !== void 0 ? _result$errorMessages : t("check_date_time_fields", {
          defaultValue: "Please check the date and time fields."
        }));
        return;
      }
      setInvalidFields(new Set());
    }
    trackEvent(ANALYTICS_EVENTS.ENCOUNTER_FLOW_REVIEW, {
      patientId: patientId
    });
    setIsReview(true);
  };
  var handleBack = function handleBack() {
    trackEvent(ANALYTICS_EVENTS.ENCOUNTER_FLOW_BACK, {
      patientId: patientId
    });
    setIsReview(false);
  };
  var handleCancel = function handleCancel() {
    trackEvent(ANALYTICS_EVENTS.ENCOUNTER_FLOW_CANCEL, {
      patientId: patientId
    });
    handleClose();
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var payload, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            trackEvent(ANALYTICS_EVENTS.ENCOUNTER_FLOW_SUBMIT, {
              patientId: patientId
            });
            setError(null);
            payload = buildSubmissionPayload({
              action: action,
              encounterConfig: encounterConfig,
              encounterMeta: encounterMeta,
              docConfig: docConfig,
              docMeta: docMeta,
              formData: formData,
              docKind: docKind,
              encounter: encounter,
              requestId: requestId,
              workspaceId: workspaceId,
              patientId: patientId,
              createdBy: ""
            });
            if (payload) {
              _context.n = 1;
              break;
            }
            setError(t("nothing_to_submit", {
              defaultValue: "Fill in the form before submitting."
            }));
            return _context.a(2);
          case 1:
            _context.p = 1;
            _context.n = 2;
            return submit.mutateAsync(payload);
          case 2:
            onClose();
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            setError(t("submit_failed", {
              defaultValue: "Submission failed. Please try again."
            }));
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var title = action === "create" ? (encounterConfig === null || encounterConfig === void 0 ? void 0 : encounterConfig.title) || t("create_encounter", {
    defaultValue: "Create encounter"
  }) : t("add_to_encounter", {
    defaultValue: "Add to encounter"
  });
  var footer = /*#__PURE__*/React.createElement(EncounterFlowFooter, {
    action: action,
    isReview: isReview,
    canReview: canReview,
    isSubmitting: submit.isLoading,
    onBack: handleBack,
    onCancel: handleCancel,
    onReview: handleReview,
    onSubmit: handleSubmit
  });
  return /*#__PURE__*/React.createElement(Modal, {
    opened: true,
    onClose: handleDismiss,
    size: "xl",
    title: title,
    closeTestId: "encounter-flow-close",
    footer: footer
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, isReview ? /*#__PURE__*/React.createElement(ReviewStep, {
    action: action,
    encounterRows: buildEncounterSummary(encounterConfig, formData),
    docTitle: (_getDocOption$label = (_getDocOption = getDocOption(docConfig, docKind)) === null || _getDocOption === void 0 ? void 0 : _getDocOption.label) !== null && _getDocOption$label !== void 0 ? _getDocOption$label : null,
    docRows: docRows
  }) : isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center py-10"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSpinner,
    spin: true,
    className: "h-6 w-6 text-sds-brand-default"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, action === "update" && encounter ? /*#__PURE__*/React.createElement(EncounterContextBanner, {
    encounter: encounter
  }) : null, action === "create" && encounterConfig ? /*#__PURE__*/React.createElement(EncounterForm, {
    config: encounterConfig,
    formData: formData,
    onFieldChange: setField,
    invalidFieldNames: invalidFields
  }) : null, showDocs && docConfig ? /*#__PURE__*/React.createElement(DocAccordions, {
    config: docConfig,
    formData: formData,
    onFieldChange: setField,
    expanded: docKind,
    onExpand: setDocKind,
    workspaceId: workspaceId,
    patientId: patientId
  }) : null), error ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-urgent-secondary"
  }, error) : null));
}